<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            System Configuration
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div>{{'LBL.LBL_SYS_CNF_MOST_OPTIONS' | translate}}</div>
        <br />
        <div>
            {{'LBL.LBL_SYS_CNF_CLICK_LINK' | translate}}
            <button type="button" class="btn btn-primary mr-3" (click)="RedirectNewConfig()">
                {{'NAV.NAV_SYSTEM_CONFIG_HTML' | translate}}
            </button>
        </div>
        <br />
        <div>{{'LBL.LBL_SYS_CNF_NEED_GUIDE' | translate}}</div>
        <br />
        <div>{{'LBL.LBL_SYS_CNF_ALTERNATE' | translate}}</div>
        <br />
        <textarea class="form-control" [(ngModel)]="ConfigURL" name="ConfigURL" id="ConfigURLText" disabled #ConfigURLText></textarea>
    </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary mr-3" (click)="DisableModalOpenEvent = false;OnSubmit(ConfigURLText)" translate>Copy URL</button>
            <button type="button" class="btn btn-secondary" (click)="DisableModalOpenEvent = false; c('close')" translate>BTN.BTN_CLOSE</button>
        </div>

</ng-template>
